const genders = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

export default genders;
